import type { ReactElement } from 'react'
import { categoryList } from '@/data/categories'
import CategoryListItem from '@/components/category/list-item'
import CategoryPickup from '@/components/category/pickup'

const pickups = categoryList.filter((c) => c.pickup)
const categories = categoryList.filter((c) => !c.pickup)

const ForProCategories = (): ReactElement | null => {

  return (
    <div className="bg-linear-to-r from-[#1F0822] to-[#3F0647]">
      <div className="container py-18">
        <h2 className="text-2xl lg:text-3xl font-medium text-center mb-4 text-white">
          あらゆる分野のクリエイターが、活躍できます
        </h2>
        <p className="text-sm sm:text-base text-ghost text-center mb-12">
          あなたが持つ複数のスキルをアピールすることも可能です
        </p>
        <div className="mb-10">
          <ul className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 text-white">
            {
              pickups.map((cat) => (
                <li key={cat.slug}>
                  <CategoryPickup
                    slug={cat.slug}
                    title={cat.name}
                    disabled
                  />
                </li>
              ))
            }
          </ul>
        </div>
        <div>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
            {
              categories.map((cat) => (
                <div key={cat.id}>
                  <CategoryListItem
                    title={cat.name}
                    slug={cat.slug}
                    disabled
                  />
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForProCategories
